import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { Achievements } from './achievements';

const routes: Routes = [
  {
    path: 'achievements',
    component: Achievements,
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AchievementsRoutingModule {}
